import axios from "@/repositories/client";

axios.getOrders = (query, pagination) => {

  let options = {
    params: {
      search: query,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get('athena/v1/orders', options)
    .then(response => {
      return response.data;
    });
};

axios.getOrder = (order) => {
  return axios.get(`athena/v1/orders/${order}`)
    .then(response => {
      return response.data.data;
    });
};

export default axios;